import { cycleCountRuleTypeSchema } from "@redotech/redo-inventory-common/cycle-counts";
import { cycleCountRuleIdFormat } from "@redotech/redo-model/ids";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const getCycleCountRule = unaryRpc({
  name: "getCycleCountRule" as const,
  input: z.object({ id: cycleCountRuleIdFormat.schema }),
  output: z.object({
    id: cycleCountRuleIdFormat.schema,
    name: z.string(),
    description: z.string().nullable(),
    type: cycleCountRuleTypeSchema,
    status: z.enum(["live", "disabled", "draft"]),
    data: z.unknown(),
    dueDaysAfterCreation: z.int(),
    assignedRole: z.string().nullable(),
    assignedUserId: z.string().nullable(),
    createdAt: z.date(),
    updatedAt: z.date(),
  }),
});
